import { Activity } from '../../../lib/types/models/ol/activity/activity'
import { ActivityInput } from '../../../lib/types/models/ol/activity/activity-input'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export const createActivity = async (input: ActivityInput & { olId: number }) => {
  const { olId, ...data } = input

  return restApiClient
    .url(constructApiUrl(API.ols.createActivity.url, { olId }))
    .post<Activity, ActivityInput>(data)
}
